// extracted by mini-css-extract-plugin
module.exports = {"title":"_3QHeC","editionTitle":"_1q2RD","group":"_9JbvM","paymentBox":"_3ugae","molotovPayBox":"_1j3Fw","info":"_3hFBI"};